import type { RootState } from '../store';

export const getInsurancePlan = (state: RootState) => state.insurancePlan.plan;
